import { render, staticRenderFns } from "./TransitionSlide.vue?vue&type=template&id=971dc2d2&scoped=true"
import script from "./TransitionSlide.vue?vue&type=script&lang=js"
export * from "./TransitionSlide.vue?vue&type=script&lang=js"
import style0 from "./TransitionSlide.vue?vue&type=style&index=0&id=971dc2d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971dc2d2",
  null
  
)

export default component.exports